module.exports = __webpack_public_path__ + "media/img/event/speakers/Stephen-Mullock-fcbfc48b5f4e6330a91d7c30dc4c8abe.jpg";